export default {
    ME: 'ME',
    EPP: 'EPP',
    MEI: 'MEI'
}
